// mailto: in the shell (architecture/MAIL.md §3.2a) — the in-app composer is
// the DEFAULT ACTION of a plain left-click on a mailto: link, never a
// pre-emption of the surface that owns the link.
//
// The shell root declares `onDocumentClick` (app.js): ONE bubble-phase
// document listener that DOMQL owns (FA503). An element's own onClick runs
// before it — DOMQL delegates element clicks to <html>, below document — so a
// surface that handles the click itself claims it with preventDefault, and
// the shell yields: the CRM contact dialog's Email action and the email in
// its head open the CRM's own composer on the Email tab. A plain mailto link
// (no handler, or one that lets the click through, like Link's router) opens
// the in-app composer through openMailComposeFromMailto (mail
// functions/compose.js) while the `mail` feature is on.
//
// The listener used to be a raw CAPTURE listener in wireGlobalListeners.js
// that ran before every element handler and stopped the click: it took
// every mailto click, the CRM's included (crm-modal's live check on dev
// crm-app 1.0.87 opened the Mail app and saved an empty draft). A modifier
// or non-primary click is the person asking for their own mail client and
// stays with the browser.
//
// `this` is the shell root element; answers true when it opened the composer.
export const mailtoComposeDefault = function mailtoComposeDefault(e) {
  const shell = this
  if (!e || e.defaultPrevented) return false
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false
  const target = e.target
  const anchor =
    target && typeof target.closest === 'function' ? target.closest('a[href^="mailto:" i]') : null
  if (!anchor || !shell || typeof shell.call !== 'function') return false
  const root = shell.state ? shell.state.root || shell.state : null
  if (!shell.call('featureEnabled', root, 'mail')) return false
  if (!shell.call('openMailComposeFromMailto', anchor.getAttribute('href'))) return false
  e.preventDefault()
  return true
}
